/**
 * 根据重试次数获取下一次重试的时间间隔，返回ms
 * @param count 重试次数，一般从1开始
 */
export function getRetryIntervalByRetryCount(count: number): number {
    switch (count) {
        case 0:
        case 1:
            return 3e3;
        case 2:
            return 5e3;
        default:
            return 8e3;
    }
}
